import React from "react";
import AppLayout from "@/Layouts/AppLayout";
import { useTitle } from "@/Utilities/Hooks";

import { BlockButton, Subheader } from "@/Components/";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { House } from "@/Icons";
import { usePage } from "@inertiajs/inertia-react";
import { ClientCard } from "@/Pages/Agency/Clients/Partials/ClientCard";
import { EmptyState } from "@/Components";

export default function Home() {
  useTitle("Home");

  const organizations = usePage().props?.organizations?.data || [];
  const favoriteIds =
    usePage().props?.auth?.user?.data?.meta?.favorite_organizations || [];

  const favoriteOrganizations = organizations.filter((o) =>
    favoriteIds.includes(o.id),
  );

  return (
    <div className="flex flex-col items-stretch gap-4">
      <div className="my-4 flex flex-shrink-0 flex-row flex-wrap gap-4 md:flex-nowrap">
        <BlockButton
          title="Clients"
          text="Manage clients"
          href={route("agency.clients")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
        <BlockButton
          title="Emission factors"
          text="Create new emission factor"
          href={route("agency.factors.createForm")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
        <BlockButton
          title="Global activities"
          text="Create new activities"
          href={route("agency.question")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
      </div>

      <div className="flex flex-col gap-2">
        <Subheader margin="" className="mt-12">
          Your favorite organizations
        </Subheader>
        {favoriteOrganizations.length > 0 && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4">
            {favoriteOrganizations.map((organization) => (
              <ClientCard
                key={organization.id}
                organization={organization}
                favoriteIds={favoriteIds}
              />
            ))}
          </div>
        )}
        {favoriteOrganizations.length === 0 && (
          <EmptyState
            title="You have no favorite clients yet"
            text="To add a client as favorite, head over to clients and mark your favorites"
            buttonText="Manage clients"
            buttonRoute={route("agency.clients")}
          />
        )}
      </div>
    </div>
  );
}

Home.layout = (page) => {
  const user = page?.props?.auth?.user?.data;
  return (
    <AppLayout>
      <OrganizationLayout
        header={`Hello ${user.firstname}`}
        icon={
          <LayoutIcon>
            <House size={40} className="text-black" />
          </LayoutIcon>
        }
        byline="Manage your clients, and build libraries of emission factors and global activities for them to use."
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
